import { ListItem } from '@/components/Ui';
import { FadeLoader } from 'react-spinners';
import { useEpreuve } from './Epreuve.hook';

export const EpreuveList = () => {
  const { epreuveData, loadingData, seletedExam, setSeletedExam } =
    useEpreuve();

  return (
    <div className="overflow-auto mb-6 pl-2">
      {loadingData ? (
        <div className="w-full h-[100vh] flex items-center justify-center">
          <FadeLoader color="#FEC200" />
        </div>
      ) : (
        <>
          {epreuveData?.map((epreuve, index) => (
            <ListItem
              onClick={() => setSeletedExam(epreuve)}
              listItemStyle={`!bg-black !hover:border-l-[#FEC200] ${epreuve?.year === seletedExam?.year ? '!border-l-[#FEC200]' : ''}`}
              key={index}
              connector
              connectorStyle="before:h-[calc(100%_-_24px)]"
              subItems={epreuve?.disciplines?.flatMap((discipline) =>
                discipline?.exams?.map((exam) => ({
                  children: (
                    <div
                      className="flex flex-col"
                      onClick={() => window.open(exam.content, '_blank')}
                    >
                      <span className="text-white">{exam?.name}</span>
                    </div>
                  ),
                  connector: true,
                })),
              )}
            >
              <div className="flex flex-col">
                <h3 className="text-[15.478px] not-italic font-bold pb-2 leading-[16.509px]">
                  {epreuve?.year}
                </h3>
              </div>
            </ListItem>
          ))}
        </>
      )}
    </div>
  );
};
